<template>
    <div id="user-add-tab-info">
      <!-- Content Row -->
      <div class="vx-row">
        <div v-if="!parentVerified" class="vx-col md:w-1/2 w-full">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <span class="font-medium text-lg leading-none">Ingrese el documento de identidad</span>
              </div>
              <vs-divider />
            </div>
            <div class="flex flex-col">
              <label class="vs-input--label w-full">Documento de identidad</label>
              <div class="flex">
                <div class="w-1/2">
                  <v-select
                    v-model="data_local.card_type_id"
                    :reduce="card_type_id => card_type_id.card_type_id"
                    :options="cardTypeOptions"
                    :clearable="false"
                    name="card_type_id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :searchable="false"
                  />
                </div>
                <div class="w-1/2 pl-4">
                  <vs-input
                    class="w-full"
                    v-model="data_local.card_id"
                    autocomplete="off"
                    v-validate="'required|alpha_num|max:15'"
                    name="card_id"
                    placeholder="Número de Documento"
                    data-vv-as="Número de Documento"
                    :disabled="!data_local.card_type_id"
                  />
                </div>
                <div class="flex pl-4">
                  <vs-button color="primary" @click="verifyParent">Verificar</vs-button>
                </div>
              </div>
              <span v-show="parentErrorMsg" class="text-danger mt-2">{{ parentErrorMsg }}</span>
            </div>
        </div>
        <div v-if="parentVerified" class="vx-col w-full">

          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">Datos personales</span>
              </div>
              <vs-divider />
            </div>

            <vs-input class="w-full mt-4" label="Nombre" autocomplete="off" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" autofocus />
            <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

            <vs-input class="w-full mt-4" label="Apellido" autocomplete="off" v-model="data_local.last_name" v-validate="'required|alpha_spaces'" name="last_name" />
            <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>

            <div class="mt-4 flex flex-wrap">
              <div class="w-1/2">
                <vs-input class="w-full" label="Email" autocomplete="off" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" />
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
              <div class="w-1/2">
                <vs-input label="Teléfono" type="number" autocomplete="off" class="w-full pl-4" v-model="data_local.phone_number" name="phone_number"/>
                <span class="text-danger text-sm"  v-show="errors.has('phone_number')">{{ errors.first('phone_number') }}</span>
              </div>
            </div>

            <div class="mt-4 flex flex-wrap">
              <label class="vs-input--label w-full">Documento de identidad</label>
              <div class="w-1/2">
                <v-select
                  v-model="data_local.card_type_id"
                  :reduce="card_type_id => card_type_id.card_type_id"
                  :options="cardTypeOptions"
                  :clearable="false"
                  name="card_type_id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :disabled="data_local.card_type_id !== ''"
                  :searchable="false"
                />
              </div>
              <span class="text-danger text-sm"  v-show="errors.has('card_type_id')">{{ errors.first('card_type_id') }}</span>
              <div class="w-1/2 pl-4">
                <vs-input
                  class="w-full"
                  v-model="data_local.card_id"
                  v-validate="'required|alpha_num|max:15'"
                  name="card_id"
                  placeholder="Número de Documento"
                  data-vv-as="Número de Documento"
                  :disabled="data_local.card_id !== ''"
                />
                <span class="text-danger text-sm"  v-show="errors.has('card_id')">{{ errors.first('card_id') }}</span>
              </div>
            </div>

            <div class="mt-4">
              <label>Fecha de Nacimiento</label>
              <div class="flex flex-wrap">
                <datepicker :disabledDates="disabledDates" :useUtc="true" :openDate="openDate" :format="dateFormat" v-model="birthdayLocal" autocomplete="off" v-validate="'required'" name="birthday_date"></datepicker>
                <span class="text-danger text-sm"  v-show="errors.has('birthday_date')">{{ errors.first('birthday_date') }}</span>
              </div>
            </div>

            <div class="mt-4 flex flex-wrap">
              <div class="w-1/2">
                <vs-input class="w-full" label="Dirección" v-model="data_local.address" autocomplete="off" name="address" v-validate="'required'" data-vv-as="Dirección"/>
                <span class="text-danger text-sm"  v-show="errors.has('address')">{{ errors.first('address') }}</span>
              </div>
              <div class="w-1/4 pl-4">
                <vs-input class="w-full" label="Ciudad" v-model="data_local.city" autocomplete="off" name="city" v-validate="'required'" data-vv-as="Ciudad"/>
                <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>
              </div>
              <div class="w-1/4 pl-4">
                <vs-input class="w-full" label="Código Postal" v-model="data_local.zip_code" autocomplete="off" name="zip_code" v-validate="'required'" data-vv-as="Código Postal"/>
                <span class="text-danger text-sm"  v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
              </div>
            </div>
          </div>

          <parent-related-students />

        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row mt-12">
        <div class="vx-col w-full mt-12">
          <div class="mt-12 flex flex-wrap items-center justify-end">
            <vs-button v-if="parentVerified" class="ml-auto mt-12" @click="save_changes" id="saveButton" :disabled="!validateForm">Guardar</vs-button>
            <vs-button class="ml-4 mt-12" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import Datepicker from 'vuejs-datepicker';
  import vSelect from 'vue-select';
  import ParentRelatedStudents from '../components/ParentRelatedStudents.vue';


  export default {
    components: {
      Datepicker,
      vSelect,
      ParentRelatedStudents
    },
    data() {
      return {
        data_local: {
          name: "",
          last_name: "",
          email: "",
          card_id: "",
          birthday_date: "",
          avatar: 0
        },
        parentVerified: false,
        parentErrorMsg: null,
        parentData: {
          card_id: "",
          card_type_id: "",
          card_type: ''
        },
        student_data: {
          id_document_type: '',
          document: '',
        },
        studentsData: [],

        cardTypeOptions: [],

        backgroundLoading: 'primary',
        colorLoading: '#fafafa',
        loading : false,

        disabledDates: {
          from: new Date(new Date().getFullYear()-16, new Date().getMonth(), new Date().getDay()),
        },
        openDate: new Date(new Date().getFullYear()-18, new Date().getMonth(), new Date().getDay()),
        dateFormat: "dd-MM-yyyy",
      }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.data_local.name && this.data_local.last_name && this.data_local.email && this.data_local.card_type_id && this.data_local.card_id && !this.loading
      },
      birthdayLocal: {
        get() {
          return this.data_local.birthday_date
        },
        set(val) {
          this.data_local.birthday_date = val
        }
      },
    },
    methods: {
      save_changes() {
        this.data_local.name = this.data_local.name.trim().replace(/ +(?= )/g,'')
        this.data_local.last_name = this.data_local.last_name.trim().replace(/ +(?= )/g,'')
        this.data_local.id_pupils = this.studentsData.length > 0 ? this.studentsData.map(student => student.id_pupil) : []

        if(!this.validateForm) return

        this.disableSaveButton()

        this.$store.dispatch("userManagement/addParent", this.data_local)
        .then(response => {
          if (response.status && response.msg === '') {
            this.openUserCreatedDialog()
          } else {
            if (response.data && response.data.profile) this.openUserCreatedDialog()
            this.showAddError(response.msg)
          }
        })
        .catch(error => {
          this.showAddError(error)
        })
      },
      reset_data() {
        if (
          JSON.stringify(this.data_local) === JSON.stringify(this.originalData)
          || this.studentsData.length === 0
        ) {
          this.redirectToUsers()
          return
        }
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Cancelar',
          text: '¿Estás seguro que deseas cancelar? Se perderán los cambios realizados',
          acceptText: 'Si',
          accept: this.redirectToUsers,
        })
      },
      openUserCreatedDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'success',
          title: `Acudiente Creado`,
          text: `Se han enviado los datos de acceso por email a ${this.data_local.email}`,
          acceptText: "Aceptar",
          accept: this.closePrompt
        })
      },
      showNotify(type,title,text) {
        this.$vs.notify({
          color: type || 'success',
          title: title || 'Correcto!',
          text: text || '',
          time: 8000,
          position: 'top-center',
          iconPack: 'feather',
          icon:'icon-check',
        })
      },
      showAddError(msg) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: msg || 'No se pudo agregar el acudiente.',
          time: 8000,
          position: 'top-center',
          iconPack: 'feather',
          icon:'icon-alert-circle',
        })
        this.enableSaveButton()
      },
      disableSaveButton() {
        this.loading = true
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: "#saveButton",
          scale: 0.45
        })
      },
      enableSaveButton() {
        this.loading = false
        this.$vs.loading.close("#saveButton > .con-vs-loading")
      },
      closePrompt() {
        setTimeout(() =>{
          this.redirectToUsers()
        }, 100)
      },
      redirectToUsers() {
        if (this.$route.fullPath !== '/users?tab=1')  this.$router.push('/users?tab=1')
      },
      verifyParent() {
        if (!this.data_local.card_type_id) {
          this.parentErrorMsg = 'Debe seleccionar el tipo de documento'
          return
        } else if (this.data_local.card_id === '') {
          this.parentErrorMsg = 'Debe ingresar el número de documento'
          return
        }
        this.parentErrorMsg = null

        this.$vs.loading()
        this.$store.dispatch('userManagement/getParentByCardId', this.data_local).then((response) => {
          this.$vs.loading.close()
          if (response.status && response.data.account && response.data.account.length > 0 && response.data.account[0].id) {
            this.parentErrorMsg = response.data.account.length == 1 ? `El ${response.data.account[0].profile_type_id == 1 ? 'acudiente' : 'usuario'} ${response.data.account[0].name} ${response.data.account[0].last_name} (ID ${response.data.account[0].id}) ya se encuentra registrado desde el ${new Date(response.data.account[0].created_at).toLocaleDateString('es-AR', this.$localeDateOptions)} a través de la ${response.data.account[0].origin == 'APP' ? 'App Tiptap' : 'Web Pagos' }` : 'Se han encontrado usuarios registrados con este número de documento'
          } else {
            this.parentErrorMsg = null
            this.parentVerified = true
          }
        }).catch((error) => {
          console.error(error)
          this.$vs.loading.close()
        })
      }
    },
    created() {
      this.originalData = JSON.parse(JSON.stringify(this.data_local))
      this.cardTypeOptions = this.$store.state.AppData.cardTypes
    }
  }
  </script>

  <style lang="scss">
    .mt-4 > label {
      font-size: 12px;
    }
    input[type="number"] {
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      -moz-appearance: textfield;
    }
  </style>
